import { render } from "./ProductsListPage.vue?vue&type=template&id=a95d4772"
import script from "./ProductsListPage.vue?vue&type=script&lang=js"
export * from "./ProductsListPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__